import { MAX_NUMBER_OF_PAGES, MIN_BOX_BOOK_NUMBER_OF_PAGES } from 'common/utils/bookSize.constants'
import { NAVIGATION } from 'artkive/constants/tracker/mainNavigation'
import { MOSAIC_SIZES } from 'artkive/utils/constants'
import routes from 'artkive/utils/routes'

import ArtBook from 'images/ecom/home/Home-ArtBook.jpg'
import FramedMosaic from 'images/ecom/home/Home-FramedMosaic.jpg'
import Press from 'images/ecom/home/Press.png'
import Press2 from 'images/ecom/home/Press-2.png'
import Press3 from 'images/ecom/home/Press-3.png'

export const SLIDES = [
  {
    id: 0,
    image: Press,
    title: '2021 GH Storage Award Winner: Superb Artwork Collector',
    body: "What parent doesn't want to save all their kid's artful creations? But there isn't space. Enter Artkive. The company sends you a box to fill with your child's drawings. Then it professionally photographs them and has you proof the images before turning them into a hardcover book.",
  },
  {
    id: 1,
    image: Press2,
    title: 'The Most Adorable Solution For Saving All Of Your Kid’s Art',
    body: 'Anyone with school-aged kiddos knows that the projects stack up, and as much as you would love to proudly display each painting or drawing, it just becomes a bit of a cluttered mess. This is where Artkive comes in.',
  },
  {
    id: 2,
    image: Press3,
    title: '13 Products That Finally Helped My Family Get Organized',
    body: 'Artkive is a genius solution to the too-much-artwork problem. You order a box which you then fill up with the artwork and sentimental papers you want to save. It then gets mailed back to Artkive, who turns the art into a beautiful book.',
  },
]

export const PRODUCTS = [
  {
    id: 'Art Books',
    title: 'Kids Art Books',
    image: ArtBook,
    url: routes.books,
    descriptionItems: [
      'Professional photography and editing of art with a digital proof to review and customize',
      `Features between ${MIN_BOX_BOOK_NUMBER_OF_PAGES}-${MAX_NUMBER_OF_PAGES} images`,
      'Premium matte printing in two size options: 8"x8" or 11"x8.5"',
      'Access to your digital images on our website and the iOS app',
    ],
    trackerEvent: NAVIGATION.ART_BOOK_CLICK,
    trackerOptions: {
      section: 'products_section',
    },
  },
  {
    id: 'Framed Mosaics',
    title: 'Framed Mosaics',
    image: FramedMosaic,
    url: routes.mosaics,
    descriptionItems: [
      `Showcases ${MOSAIC_SIZES.CLASSIC} or ${MOSAIC_SIZES.SMALL} of your images`,
      '26"x26" or 14"x14" solid wood, gallery frame and professional matting',
      'Professional photography, editing of each piece of art, and a digital proof to review',
      'Access to your digital images on our website and the iOS app',
    ],
    trackerEvent: NAVIGATION.MOSAIC_CLICK,
    trackerOptions: {
      section: 'products_section',
    },
  },
]
